export class ChangeShowOwnAgent {
   public static readonly type = '[AgentListSettings] Change show own agent';

   constructor(public brickInstanceId, public showOwnAgent: boolean) {}
}

export class ChangeGroupsForAgentList {
   public static readonly type = '[AgentListSettings] Change groups for agent list';

   constructor(public brickInstanceId, public groupIdsForAgentList: number[]) {}
}
